import { Container } from "reactstrap";

// Plain navy banner shown on every admin page. The KPI stat cards
// (Customers / Applications / Loans / Disbursed) were removed on request.
const Header = () => {
  return (
    <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
      <Container fluid>
        <div className="header-body" />
      </Container>
    </div>
  );
};

export default Header;
